import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "";

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Flag para prevenir redirecciones infinitas
let isLoggingOut = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si el token expiró y no estamos ya en proceso de logout
    if (error.response?.status === 401 && !isLoggingOut) {
      isLoggingOut = true;
      
      // Limpiar datos locales
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("usuario");
      
      // Redirigir a login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const resetLogoutFlag = () => {
  isLoggingOut = false;
};